export default {
  title: '',
  homeMenu: {
    name: '重置密码',
    desc: '重置或者修改密码'
  }
}
